var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2.5C7.27614 2.5 7.5 2.72386 7.5 3V4H16.5V3C16.5 2.72386 16.7239 2.5 17 2.5C17.2761 2.5 17.5 2.72386 17.5 3V4H19C20.6569 4 22 5.34315 22 7V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V7C2 5.34315 3.34315 4 5 4H6.5V3C6.5 2.72386 6.72386 2.5 7 2.5ZM16.5 5V6C16.5 6.27614 16.7239 6.5 17 6.5C17.2761 6.5 17.5 6.27614 17.5 6V5H19C20.1046 5 21 5.89543 21 7V10.5H3V7C3 5.89543 3.89543 5 5 5H6.5V6C6.5 6.27614 6.72386 6.5 7 6.5C7.27614 6.5 7.5 6.27614 7.5 6V5H16.5ZM3 11.5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V11.5H3Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.cb8f3d7b7edef35921024ce19be16e3b.svg";
export { ForwardRef as ReactComponent };